// extracted by mini-css-extract-plugin
export default {"root":"t-FRg","intro":"sD+2g","action":"U5JiF","button":"Yo0jN"};